import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { getActiveProfileFromState } from '~/core/util/account';
import BookingWidgetConfirm from './BookingWidgetConfirm';
import { hideModal, setRuntimeVariable, showModal } from '~/actions/runtime';
import {
  CREATE_VERIFIED_USER_PROFILE,
  INSURANCE_FLOW_STEP_BEGINNING,
  TYPE_SELF,
  TYPE_SKIP,
} from '../../../constants/index';
import history from '../../../core/history/index';
import {
  clearSuccessfulBookingData,
  resetUserProfile,
  setBookingProfilePending,
} from '~/actions/newBooking';
import { profileFormSubmission } from '~/actions/profile';
import { insuranceFormSubmission } from '~/actions/insurance';
import { resetLoginData } from '~/actions/login';
import { doNpiCheck, sufficientInsuranceDataToDisplayInsuranceCard } from '~/core/util/insurance';
import { isInsuranceDisabled, isPhotoIdUploadEnabledForEntrypoint } from '~/core/util/location';
import {
  PHOTO_ID_UPLOAD,
  PHOTO_ID_UPLOAD_ORIGIN_BOOKING_WIDGET,
} from '~/core/util/bookingFlowRouting';
import { getNewBookingLocale } from '~/selectors/newBooking';
import { analyticsTrackEvent } from '~/core/analytics';
import { ADD_FAMILY_MEMBER_SUBMIT } from '~/core/analytics/events';
import {
  ADD_INSURANCE,
  DECIDE_LATER_PHOTO_ID_UPLOAD,
  POST_PAYMENT_FINISH,
} from '~/routes/addInsurance/constants';
import { getIsFamilyVisitActivatedInBookingWidget } from '~/ducks/bookingWidgetFamilyBooking';
import { redirectToAddPaymentMethodDuringNewBookingPage } from '~/components/Payments/util';

type InsuranceFormType = {
  insurerType?: string;
  firstName?: string;
  lastName?: string;
};

function mapStateToProps(state: any) {
  return {
    locale: getNewBookingLocale(state),
    location: state.location,
    newBooking: state.newBooking,
    searchPreferences: state.searchPreferences,
    account: state.login.account || {},
    userProfile: getActiveProfileFromState(state),
    isLoginModalOpen: !isEmpty(state.runtime.modal) ? state.runtime.modal.loginModal : false,
    login: state.login,
    pastBookings: state.pastBookings,
    insurers: state.insurers,
    npi: state.npi,
    eligibilityCheck: state.eligibilityCheck,
    position: state.position,
    tracking: state.tracking,
    isInsuranceModalOpen: !isEmpty(state.runtime.modal)
      ? state.runtime.modal.insuranceModal
      : false,
    waitTime: !isEmpty(state.waitTime) ? state.waitTime.waitTime : null,
    accountSummary: state.account.fullSummary,
    flowStep: state.runtime.flowStep || INSURANCE_FLOW_STEP_BEGINNING,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    setFlowStep: (step: any) => {
      dispatch(setRuntimeVariable({ name: 'flowStep', value: step }));
    },

    resetData: () => {
      dispatch(resetLoginData());
    },

    resetLogin: (location: any) => {
      dispatch(clearSuccessfulBookingData());
      history.replace(`/book-online/${location.id}`);
    },

    setBookingProfilePending: (value: boolean) => {
      if (value) {
        dispatch(setBookingProfilePending(true));
        dispatch(resetUserProfile());
      } else {
        dispatch(setBookingProfilePending(false));
      }
    },

    handleMobileSecondFormSubmit: (inputForm: any, props: any) =>
      dispatch((dispatch: any, getState: any) => {
        const { location } = props;
        const { isPaymentsEnabled, isPaymentDuringBookingEnabled } = location;
        const includePaymentPage = isPaymentsEnabled && isPaymentDuringBookingEnabled;
        const manipulateForm = () => {
          const newForm = inputForm;
          if (
            inputForm.payment === TYPE_SELF ||
            inputForm.payment === TYPE_SKIP ||
            isInsuranceDisabled(location)
          ) {
            // Prepare and dispatch insurance information
            const insuranceForm: InsuranceFormType = {};
            insuranceForm.insurerType = isInsuranceDisabled(location)
              ? TYPE_SKIP
              : inputForm.payment;
            insuranceForm.firstName = inputForm.firstName;
            insuranceForm.lastName = inputForm.lastName;
            dispatch(insuranceFormSubmission(insuranceForm));

            newForm.insurerType = isInsuranceDisabled(location) ? TYPE_SKIP : inputForm.payment;
          }

          delete newForm.payment;
          return newForm;
        };

        const form = manipulateForm();

        if (props.newBooking?.bookingProfilePending) {
          dispatch({
            type: CREATE_VERIFIED_USER_PROFILE,
            formValues: form,
            accountId: props.accountSummary.id,
            currentlyBooking: true,
          });
          analyticsTrackEvent(ADD_FAMILY_MEMBER_SUBMIT);
          dispatch(
            profileFormSubmission({
              ...form,
              phone: props.accountSummary.phone,
              email: props.accountSummary.email,
            })
          );
          dispatch(setBookingProfilePending(false));
        } else {
          dispatch(profileFormSubmission(form));
          ``;
        }

        const isFamilyVisitActivated = getIsFamilyVisitActivatedInBookingWidget(getState());
        if (isFamilyVisitActivated) {
          history.push('/additional-patients/bw');
          return;
        }

        const onFinish = () => history.push('/submitBooking');

        // if pay cash, submitting form
        if (
          form.insurerType === TYPE_SELF ||
          form.insurerType === TYPE_SKIP ||
          isInsuranceDisabled(location)
        ) {
          if (isPhotoIdUploadEnabledForEntrypoint(location, 'bookingWidget')) {
            if (includePaymentPage) {
              const nextPage =
                form.insurerType === TYPE_SKIP && !isInsuranceDisabled(location)
                  ? DECIDE_LATER_PHOTO_ID_UPLOAD
                  : PHOTO_ID_UPLOAD.replace('/', '');

              redirectToAddPaymentMethodDuringNewBookingPage(location.id, nextPage);
              return;
            }
            history.push(`${PHOTO_ID_UPLOAD}/${PHOTO_ID_UPLOAD_ORIGIN_BOOKING_WIDGET}`);
            return;
          }
          includePaymentPage
            ? redirectToAddPaymentMethodDuringNewBookingPage(location.id, POST_PAYMENT_FINISH)
            : onFinish();
          return;
        }
        if (
          !isEmpty(form.insuranceProfile) &&
          sufficientInsuranceDataToDisplayInsuranceCard(form.insuranceProfile)
        ) {
          doNpiCheck(props, onFinish, dispatch);
          return;
        }

        if (includePaymentPage) {
          history.push(`/payments/add-card-bf/${ADD_INSURANCE}`);
          return;
        }

        history.push('/add-insurance/bw');
        return;
      }),

    showModal: (modalId: string) => dispatch(showModal(modalId)),
    hideModal: (modalId: string) => dispatch(hideModal(modalId)),
  };
}

const ConnectedBookingWidgetConfirm = connect(
  mapStateToProps,
  mapDispatchToProps
)(BookingWidgetConfirm);

export default () => ({
  chunks: ['bookingWidgetConfirm'],

  component: <ConnectedBookingWidgetConfirm />,
  accountWrapper: {
    loginRequired: false,
  },
});

if (module.hot) {
  module.hot.accept();
}
